export const assetBaseUrl = '/api/gateway/metabase';
